import React, { Component } from 'react';
import { Menu } from 'semantic-ui-react';
import { injectIntl, defineMessages } from 'react-intl';
import { withRouter, Redirect } from 'react-router-dom';

import * as commonVar from 'libs/commonVar';
import './TemplateSideMenu.css';

class TemplateSideMenu extends Component {
  changeURL = (targetURL) => {
    this.props.history.push(targetURL);
  }

  render() {

    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const pathname = this.props.location.pathname;
    const { changeURL } = this;

    return (
      <div className={'template-sidebar-menu'}>
        <Menu vertical className={'template-menu'}>
          <Menu.Item>
            <Menu.Menu>
              <Menu.Item
                className="template-item"
                active={pathname === '/main/allTemplate/examtemplate'}
                onClick={() => changeURL('/main/allTemplate/examtemplate')}
              >
                <div className={'icon template'} />
                {defineMessages(formatMessage({ id: 'MyPageMenu_2', defaultMessage: '훈련 템플릿' }))}
              </Menu.Item>
              <Menu.Item
                className="template-sub-item"
                active={pathname === '/main/allTemplate/examtemplate/phishing'}
                onClick={() => changeURL('/main/allTemplate/examtemplate/phishing')}
              >
                {defineMessages(formatMessage({ id: 'MyPageMenu_7', defaultMessage: '피싱 페이지' }))}
              </Menu.Item>
            </Menu.Menu>
          </Menu.Item>

          {commonVar.isEdu === 1 &&
            <Menu.Item>
              <Menu.Menu>
                <Menu.Item
                  className="template-item"
                  active={pathname === '/main/allTemplate/edutemplate'}
                  onClick={() => changeURL('/main/allTemplate/edutemplate')}
                >
                  <div className={'icon edu'} />
                  {defineMessages(formatMessage({ id: 'MyPageMenu_11', defaultMessage: '교육 템플릿' }))}
                </Menu.Item>
                <Menu.Item
                  className="template-sub-item"
                  active={pathname === '/main/allTemplate/edutemplate/quiz'}
                  onClick={() => changeURL('/main/allTemplate/edutemplate/quiz')}
                >
                  {defineMessages(formatMessage({ id: 'Edu_57', defaultMessage: '퀴즈' }))}
                </Menu.Item>
              </Menu.Menu>
            </Menu.Item>}

        </Menu>
      </div>
    )
  }
}

export default withRouter(injectIntl(TemplateSideMenu));


// WEBPACK FOOTER //
// ./src/script/components/exam/TemplateSideMenu.js